import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { AdhocTaskChooser } from '@/components/logbook/task/AdhocTaskChooser';
import { DriveOnDisplayableTaskDto as DriveOnTask } from '@/generated/model';
import { Stack } from '@mui/material';
import { useDriveOnContext } from '@/contexts/DriveOnContext';
import { TaskList } from '@/components/logbook/task/TaskList';

import './ChooseTask.css';

type ChooseTaskProps = {
  onSelect: (task: DriveOnTask | undefined) => void;
};

const adhocTasks = [
  {
    eventusId: '111',
    costCenter: 'adhoc',
    taskName: 'Üzemzavar',
    consumptionLocation: '',
    technicalLocation: '',
    visible: true,
  },
  {
    eventusId: '222',
    costCenter: 'adhoc',
    taskName: 'Szervíz',
    consumptionLocation: '',
    technicalLocation: '',
    visible: true,
  },
  {
    eventusId: '333',
    costCenter: 'adhoc',
    taskName: 'Egyéb',
    consumptionLocation: '',
    technicalLocation: '',
    visible: true,
  },
] satisfies DriveOnTask[];

export function ChooseTask({ onSelect }: ChooseTaskProps) {
  const { t } = useTranslation();
  const driveonCtx = useDriveOnContext();
  const navigate = useNavigate();
  
  function generateAdhocEventusId(): string {
    return new Date().getTime() + '';
  }

  function setTask(task: DriveOnTask) {
    if (task.eventusId !== driveonCtx.task?.eventusId) {
      driveonCtx.setTask(task);
      driveonCtx.setLogbook({
        taskName: task?.taskName,
        destination: '',
        productDescription: driveonCtx.logbook?.productDescription,
        productWeight: driveonCtx.logbook?.productWeight,
        personCount: driveonCtx.logbook?.personCount,
        trailer: '',
        workingHours: 0,
        heatingHours: 0,
        comment: '',
      });
      onSelect(task);
    } else {
      onSelect(undefined);
    }
    navigate('/menetlevel');
  }

  function setOtherTask(task: DriveOnTask) {
    if (task.eventusId !== driveonCtx.task?.eventusId) {
      task.eventusId = generateAdhocEventusId();
      driveonCtx.setTask(task);
      driveonCtx.setLogbook({
        taskName: task?.taskName,
        destination: '',
        productDescription: driveonCtx.logbook?.productDescription,
        productWeight: driveonCtx.logbook?.productWeight,
        personCount: driveonCtx.logbook?.personCount,
        trailer: '',
        workingHours: 0,
        heatingHours: 0,
        comment: '',
      });
      onSelect(task);
    } else {
      onSelect(undefined);
    }
    navigate('/menetlevel');
  }

  return (
    <>
      <div className="choose-task-container">
        <div className="title">
          <span>{t('menetlevel.choosetask.title')}</span>
        </div>
        <div className="date">
          <span>{new Date().toLocaleDateString('hu-HU')}</span>
        </div>
        <div className="subtitle">{t('menetlevel.choosetask.subtitle')}</div>
          <TaskList setTask={setTask} enableSelect={true} />
        <br/>
        <div className="subtitle">{t('menetlevel.choosetask.subtitle2')}</div>
          <Stack className="other-task-container" spacing={'0.5rem'}>
            {adhocTasks.map((t) => (
              <AdhocTaskChooser
                key={t.taskName}
                task={t}
                setTask={setOtherTask}
                expanded={undefined}
                logbook={false}
                enableSelect={true}
              />
            ))}
          </Stack>
      </div>
    </>
  );
}
